module.exports = __webpack_public_path__ + "static/media/back-track.f604dcbc.svg";